import DefaultHandler from './DefaultHandlers';

export default class PicklistHandler extends DefaultHandler {
  constructor(overrides) {
    super('picklist', overrides);
  }

  canHandle(property) {
    return super.canHandle(property);
  }

  handleField(property) {
    const { values } = property;

    const formField = super.handleField(property, 'picklist');

    if (!formField.optionList) {
      formField.optionList = [{ label: 'No filter', value: '' }, ...values];
    }

    return formField;
  }
}
